import { Info, Landmark } from "lucide-react";
import React from "react";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent } from "@/components/ui/card";
import { ScaledThumbnail } from "./ScaledThumbnail";

interface BankAccountsCardThumbnailProps {
  isHovered?: boolean;
  alwaysVisible?: boolean;
}

const ACCOUNTS = [
  {
    name: "Main Current",
    bank: "HSBC",
    balance: "£145,230",
    source: "Access Financials",
  },
  {
    name: "Reserve Account",
    bank: "Barclays",
    balance: "£98,720",
    source: "Access Financials",
  },
  {
    name: "Payroll Account",
    bank: "Lloyds",
    balance: "£43,500",
    source: "Access Payroll",
  },
];

export function BankAccountsCardThumbnail({
  isHovered = false,
  alwaysVisible = false,
}: BankAccountsCardThumbnailProps) {
  return (
    <ScaledThumbnail
      isHovered={isHovered}
      alwaysVisible={alwaysVisible}
      contentWidth={380}
    >
      <Card className="w-[380px] flex flex-col">
        <div className="flex items-center justify-between border-b px-4 py-3">
          <div className="flex items-center gap-1">
            <span className="text-lg font-semibold text-neutral-900">
              Bank Accounts
            </span>
            <Info className="h-3.5 w-3.5 text-muted-foreground" />
          </div>
          <span className="text-xs text-neutral-500">11 Aug 2026</span>
        </div>
        <CardContent className="flex-1 pt-4">
          <div className="space-y-3">
            {ACCOUNTS.map((account) => (
              <div
                key={account.name}
                className="flex items-center justify-between py-3 border-b border-gray-100 last:border-0"
              >
                <div className="flex items-center gap-3">
                  <div
                    className="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0"
                    style={{ backgroundColor: "var(--mc-neutral-bg)" }}
                  >
                    <Landmark
                      className="h-4 w-4"
                      style={{ color: "var(--mc-neutral-icon)" }}
                    />
                  </div>
                  <div>
                    <div className="text-sm font-medium text-neutral-900">
                      {account.name}
                    </div>
                    <div className="flex items-center gap-2 mt-0.5">
                      <span className="text-xs text-neutral-500">
                        {account.bank}
                      </span>
                      <Badge variant="outline" className="text-xs py-0">
                        {account.source}
                      </Badge>
                    </div>
                  </div>
                </div>
                <div className="text-right">
                  <div className="text-sm font-semibold text-neutral-900">
                    {account.balance}
                  </div>
                  <div className="text-xs text-neutral-500">GBP</div>
                </div>
              </div>
            ))}
            <div className="flex items-center justify-between pt-3 mt-1 border-t-2 border-neutral-200">
              <span className="text-sm font-semibold text-neutral-900">
                Total Cash Position
              </span>
              <span className="text-sm font-bold text-neutral-900">
                £287,450
              </span>
            </div>
          </div>
        </CardContent>
      </Card>
    </ScaledThumbnail>
  );
}

export default BankAccountsCardThumbnail;
